module.exports = __webpack_public_path__ + "media/images/about-wct-2-9335cb8ce800a2afd07dd47476b11644.jpg";